import * as React from 'react'
import { inject } from 'mobx-react'
import { CurrentCompanyStore } from '../../../stores/CurrentCompanyStore'
import { InventoryLogAPI } from '@getgreenline/inventory'
import { IInventoryLog } from '@getgreenline/inventory/build/models/inventoryLog'
import { Link } from 'react-router'
import { Routes } from '../../../constants/Routes'
import { dayjs } from '../../../utilities/dayjs'

interface Props {
  currentCompanyStore?: CurrentCompanyStore
}

interface State {
  todaysAuditLogs?: IInventoryLog[]
  todayStartDate: Date
  endDate: Date
}

@inject('currentCompanyStore', 'currentUserStore')
export class InventoryAudit extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      todayStartDate: dayjs().startOf('day').toDate(),
      endDate: dayjs().endOf('day').toDate(),
    }
  }
  async componentDidMount() {
    await this.getTodaysSortedInventoryLogs()
  }

  async getTodaysSortedInventoryLogs() {
    const { todayStartDate, endDate } = this.state
    const company = this.props.currentCompanyStore!.company!
    const logLimit = 5000
    const logs = await InventoryLogAPI.getInventoryLogs(company.id, {
      limit: logLimit,
      offset: 0,
      startDate: todayStartDate,
      endDate: endDate,
    })
    const auditLogs = logs.data.filter((log) => log.type === 'audit')

    const sortedAudits = auditLogs.sort((a, b) => {
      const valueA = Math.abs(a.updateValue)
      const valueB = Math.abs(b.updateValue)
      // sort by descending
      if (valueA > valueB) {
        return -1
      }
      if (valueA < valueB) {
        return 1
      }
      return 0
    })

    this.setState({
      todaysAuditLogs: sortedAudits,
    })
  }

  render() {
    const { company } = this.props.currentCompanyStore!
    const { todaysAuditLogs } = this.state
    const slicedTodaysAuditLogs =
      todaysAuditLogs && todaysAuditLogs.length > 5 ? todaysAuditLogs.slice(0, 5) : todaysAuditLogs

    return (
      <div>
        <h5 className='text-muted'>Today's inventory audits</h5>
        <div className='text-muted'>
          The biggest inventory discrepancies from today. View inventory logs{' '}
          <Link to={Routes.DASHBOARD_INVENTORY_LOG_REPORTS(company!.id)}>here</Link>.
        </div>
        <br />
        <table className='table'>
          <tbody>
            {slicedTodaysAuditLogs && slicedTodaysAuditLogs.length <= 0 && (
              <tr className='text-muted'>
                <td>No inventory audits today</td>
              </tr>
            )}
            {slicedTodaysAuditLogs &&
              slicedTodaysAuditLogs.map((log) => {
                return (
                  <tr key={log.id}>
                    <td>{log.entityName}</td>
                    <td>
                      <Link to={Routes.EDIT_PRODUCT(company!.id, log.productId)}>
                        {log.productName}
                      </Link>
                    </td>
                    <td
                      className={`text-right ${
                        log.updateValue > 0 ? 'text-success' : 'text-danger'
                      }`}
                    >
                      <b>{`${log.updateValue > 0 ? '+' : ''}${log.updateValue}`}</b>
                    </td>
                  </tr>
                )
              })}
          </tbody>
        </table>
      </div>
    )
  }
}
